import { ChevronLeft } from "lucide-react";
import "../../styles/caseheader.css";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const CaseHeader = ({ caseId, onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    onClick ? onClick() : navigate(-1);
  };
  return (
    <>
      <button className="back-button" onClick={handleClick}>
        <ChevronLeft width={22} height={24} /> Back
      </button>

      {caseId && <h3 className="suit-number">Suit No: {caseId}</h3>}
    </>
  );
};

CaseHeader.propTypes = {
  caseId: PropTypes.string,
  onClick: PropTypes.func,
};

export default CaseHeader;
